import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const apiUrl = process.env.REACT_APP_API_KEY_ADMIN
export const getRutasByIdClient = (setRutas, id_cliente) => {
    api.get(`${apiUrl}/admin/get-rutas?id_cliente=${id_cliente}`)
        .then((res) => {
            setRutas(res.data)

        })
        .catch((error) => {
            console.log("error", error);
        })
}
